import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  name: () => faker.lorem.word(),
  assignedTo: () => faker.internet.email(),
  xPos: () => faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
  yPos: () => faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
  enabled: true,
  amenities: () => [],
  assignments: () => [],
  parentDeskId: null,

  withAssignment: trait({
    afterCreate(desk, server) {
      const employee = server.schema.employees.first();
      const assignment = server.create('assignment', { desk, employee });
      desk.update({ assignments: [assignment] });
    },
  }),

  asUnplaced: trait({
    xPos: null,
    yPos: null,
  }),

  withReservation: trait({
    afterCreate(desk, server) {
      const user = server.create('user', 'asEmployee', {
        fullName: 'Jeffery Bezos',
        email: 'jeff.bezos@amazon.com',
      });
      server.create('reservation', { desk, location: server.schema.locations.first(), user });
    },
  }),

  withNeighborhood: trait({
    afterCreate(desk, server) {
      const neighborhood = server.create('neighborhood', {
        location: server.schema.locations.first(),
      });

      desk.update({ neighborhood });
    },
  }),
});
